import { store } from "../../store";

export const getTaxCode = taxId => {
    const { List } = store.getState();
    return List.taxCodes.find(tax => tax.id === taxId)?.code;
};

export const getAccountName = accId => {
    const { List } = store.getState();
    const accountsFlat = List.accounts.flatMap(account => {
        if (!account.children)
            return [account];
        return [account, ...account.children];
    });

    return accountsFlat.find(acc => acc.id === accId)?.name;
};

export const getPaymentMethodName = paymentMethodId => {
    const { List } = store.getState();
    return List.paymentMethods.find(i => i.id === paymentMethodId)?.name;
};

export const getLocationName = locactionId => {
    const { List } = store.getState();
    return List.locations.find(loc => loc.id === locactionId)?.name;
};

export const getTermName = termId => {
    const { List } = store.getState();
    return List.terms.find(term => term.id === termId)?.name;
};

export const getProductName = productId => {
    const { List } = store.getState();
    return List.productList.find(product => product.id === productId)?.name;
};

export const getProductUnitName = (productUnitId, product) => (
    product.units.find(unit => unit.id === productUnitId)?.label
);

export const getContactDisplayName = contactId => {
    const { List } = store.getState();
    return List.contacts.find(contact => contact.id === contactId).legal_name;
};

export const getTagName = tagId => {
    const { List } = store.getState();
    const flattenTags = List.tagGroups.flatMap(tagGroup => [...tagGroup.tags]);

    return flattenTags.find(flattenTag => flattenTag.id === tagId).name;
};

export const getFieldName = obj => {
    const { List } = store.getState();
    const fields = List.fields.transaction;

    return fields.find(field => field.id === obj.field_id).name;
};
